import React from 'react';
import { Col, Modal, Row, FormGroup } from 'react-bootstrap';
import { Label, Button } from 'fw/components';
import { Form, Switch, DatePicker, TextBox, IntBox, CurrencyBox } from 'fw/forms';
import { SponsorTypeCombo, SponsorAuto, SponsorInvoiceAuto } from 'areas/shared/controls'
import * as FormManager from 'fw/forms/form/FormManager';
import * as Notifications from 'fw/globals/Notifications';
import * as API from 'modules/app/API';
import Loading from 'layouts/public/loading/Loading'
import * as Formatting from 'fw/misc/Formatting';

class DiscountCodeGenerationPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
			title: "",
			form: {
				generateAutoCode: false,
				quantity: 1,
				invoiceAvailableBalance: "-"
			},
            visible: props.visible,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
			sponsorIdByProp: nextProps.sponsorId,
			form: {
				sponsorId: nextProps.sponsorId,
				sponsorName: "(" + nextProps.sponsorId + ") - " + nextProps.sponsorName,
				quantity: 1
			}
        });
    }

	resetForm = () => {
		this.setState(() => {
			return ({
				form: {
					generateAutoCode: false,
					quantity: 1
				}
			});
		});
	}

	load = () => {
		// Nothing to load on this tab
	}

	handleSubmit = () => {
		this.save();
	}

	handleCancel = () => {
		const me = this;

		FormManager.checkUnsavedChanges(function () {
			me.close();
			me.resetForm();
		})
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleGenerateAutoCodeChange = (value) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					generateAutoCode: value,
					manualAutoCode: value ? null : prevState.form.manualAutoCode,
					redemptionLimit: value ? 1 : prevState.form.redemptionLimit,
					quantity: !value ? 1 : prevState.form.quantity
				}
			});
		});
	}

	handleSponsorIdChange = (sponsor) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					sponsorId: sponsor != null ? sponsor.value : null,
					sponsorName: sponsor != null ? sponsor.label : null,
					paypalInvoiceId: null,
					paypalInvoiceNumber: null,
					invoiceAvailableBalance: null
				}
			});
		});
    }

	handleSponsorInvoiceIdChange = (invoice) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					paypalInvoiceId: invoice != null ? invoice.value : null,
					paypalInvoiceNumber: invoice != null ? invoice.label : null
				}
			});
		}, () => { this.getInvoiceAvailableBalance(); });
    }

	getInvoiceAvailableBalance = () => {
		API.DiscountCode.post('/discountCodeSetup/getInvoiceAvailableBalance', this.state.form.paypalInvoiceId, 
			{
				success: (r) => {
					this.setState((prevState) => {
						return ({
							form: {
								...prevState.form,
								invoiceAvailableBalance: r.data
							}
						});
					});
				}
			});
	}

	save = () => {
		if (!this._form.validate())
            return;

		const form = this.state.form;
		const me = this;

		let rq = {
			generateAutoCode: form.generateAutoCode,
			manualAutoCode: form.manualAutoCode,
			sponsorTypeCode: form.sponsorTypeCode,
			sponsorId: form.sponsorId,
			paypalInvoiceId: form.paypalInvoiceId,
			quantity: form.quantity,
			redemptionLimit: form.redemptionLimit,
			expirationDate: form.expirationDate,
			discountPercentage: form.discountPercentage,
			maximumFundsPerCoupon: form.maximumFundsPerCoupon
		};

		API.DiscountCode.post('/discountCodeSetup/generateDiscountCode', rq,
			{
				success: (r) => {
					Notifications.success(r.message);
					me.close(true);
					me.resetForm();
				},
				error: (r) => {
					Notifications.error(r.error.errorMessage);
				}
			});
	}

    close = (success) => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose(success);
        });
    }

    getBusy = () => {
        this.setState({
            busy: true
        });
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-30w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px", textAlign:"center" }}>
                        Generate Discount Code
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                            :
							<React.Fragment>
								<Form
									onChange={this.handleChange}
									onSubmit={this.handleSubmit}
									values={this.state.form}
									unsavedChangesWarning={true}
									ref={(form) => { this._form = form }}>
										<Row>
											<Col md={4}>
												<FormGroup>
													<Label required>Generate Auto-Code</Label>
													<Switch 
														value={this.state.form.generateAutoCode}
														labelLeft='No'
														labelRight='Yes'
														bsStyle='primary'
														formControl={false}
														onChange={this.handleGenerateAutoCodeChange} />
												</FormGroup>
											</Col>
											<Col md={4}>
												<FormGroup>
													<Label required>Manual Auto-Code</Label>
													<TextBox
														name="manualAutoCode"
														placeholder="Manual Auto-Code"
														maxLength={20}
														disabled={this.state.form.generateAutoCode}
														required ={!this.state.form.generateAutoCode} />
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col md={4}>
												<FormGroup>
													<Label required>Discount Type</Label>
													<SponsorTypeCombo clearable name='sponsorTypeCode' label="sponsorType" placeholder="Discount Type" required />
												</FormGroup>
											</Col>
											<Col md={4}>
												<FormGroup>
													<Label required>Sponsor (CM ID)</Label>
													<SponsorAuto
														name="sponsorId"
														placeholder='Search Sponsor...'
														formControl={false}
														value={this.state.form.sponsorId}
														text={this.state.form.sponsorName}
														onChange={(sponsor) => this.handleSponsorIdChange(sponsor)} 
														disabled={this.props.sponsorId}
														required />
												</FormGroup>
											</Col>
											<Col md={4}>
												<FormGroup>
													<Label required>Invoice/Ref. Number</Label>
													<SponsorInvoiceAuto
														name="paypalInvoiceId"
														placeholder='Search Invoice...'
														formControl={false}
														preloadMonths={24}
														value={this.state.form.paypalInvoiceId}
														text={this.state.form.paypalInvoiceNumber}
														sponsorId={this.state.form.sponsorId}
														disabled={!this.state.form.sponsorId}
														onChange={(invoice) => this.handleSponsorInvoiceIdChange(invoice)}
														required />
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col md={4}>
												<FormGroup>
													<Label required>How many codes?</Label>
													<IntBox
														name="quantity"
														placeholder="Number of codes"
														maxLength={7}
														positiveOnly
														disabled={!this.state.form.generateAutoCode}
														required ={!this.state.form.generateAutoCode} />
												</FormGroup>
											</Col>
											<Col md={4}>
												<FormGroup>
													<Label required>Redemption limit</Label>
													<IntBox
														name="redemptionLimit"
														placeholder="Redemption limit"
														maxLength={7}
														positiveOnly
														disabled={this.state.form.generateAutoCode}
														required />
												</FormGroup>
											</Col>
											<Col md={4}>
												<FormGroup>
													<Label required>Expiration date</Label>
													<DatePicker
														className='dpThin'
														name='expirationDate'
														placeholder='Select Date'
														showTime={false}
														required />
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col md={4}>
												<FormGroup>
													<Label required>Discount percentage?</Label>
													<IntBox
														name="discountPercentage"
														placeholder="Discount percentage"
														maxLength={3}
														positiveOnly
														minValue={0}
														maxValue={100}
														required />
												</FormGroup>
											</Col>
											<Col md={7}>
												<FormGroup>
													<Label required>Maximum funds per coupon</Label>
													<CurrencyBox
														name="maximumFundsPerCoupon"
														placeholder="Maximum funds per coupon"
														maxLength={7}
														required />
												</FormGroup>
												<div style={{ fontStyle: "italic", marginTop: "-10px", fontSize: "small" }}>
													Invoice available balance: <b>{Formatting.formatSignedCurrency(this.state.form.invoiceAvailableBalance)}</b>
												</div>
											</Col>
										</Row>
									</Form>
							</React.Fragment>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
					<Button onClick={this.handleSubmit} disabled={this.state.busy} bsStyle="success" type="submit">Generate</Button>
                    <Button onClick={this.handleCancel} disabled={this.state.busy}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default DiscountCodeGenerationPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/discountCodeSetup/discountCodeGeneration/DiscountCodeGenerationPopUp.js